import { gql } from '@/__generated__';

export const UnauthenticatedStreamQuery = gql(`
  query UnauthenticatedStreamQuery($id: ID!) {
    stream(id: $id) {
      id
      author {
        ...UserBadgeFragment
        xComHandle
      }
      followersCount
      name
      description
      descriptionJson
      label
    }
  }
`);
